import React from "react";
import config from "../config.js";
import ForecastRow from "./forecast_row";
import "../CSS/forecast.css";

// Order gauges the same way the map/stat blocks do.
const GAUGE_ORDER = ["lostCreek", "loop360", "bartonSpgs"];

function updatedLabel(iso) {
	if (!iso) return "";
	try {
		const when = new Intl.DateTimeFormat("en-US", {
			weekday: "short",
			hour: "numeric",
			minute: "2-digit",
			timeZone: "America/Chicago",
		}).format(new Date(iso));
		return `Updated ${when}`;
	} catch {
		return "";
	}
}

// The forecast.json "now" snapshot goes stale between daily model runs, so
// the Now cell prefers the live USGS reading the page already fetches.
function liveFlow(liveData, siteKey) {
	const site = liveData && liveData[siteKey];
	if (!site || !site.hasData || !site.flow) return null;
	const v = parseFloat(site.flow.average);
	return Number.isNaN(v) ? null : v;
}

function ForecastSection({ forecast, liveData }) {
	const loading = !forecast;
	const live = forecast && forecast.mode === "live" && forecast.gauges;

	return (
		<section className="wis-forecast">
			<div className="wis-forecast-inner">
				<header className="wis-forecast-head">
					<h2 className="wis-forecast-title">7-Day Flow Forecast</h2>
					<p className="wis-forecast-sub">
						Projected flow at each gauge around 3 PM Central, from the Barton Creek flow model
					</p>
				</header>

				{loading && (
					<div className="wis-forecast-note">Loading forecast…</div>
				)}

				{!loading && !live && (
					<div className="wis-forecast-note">
						Live forecast temporarily unavailable — current conditions
						above are up to date.
					</div>
				)}

				{live &&
					GAUGE_ORDER.filter((k) => forecast.gauges[k]).map((k) => (
						<ForecastRow
							key={k}
							gauge={forecast.gauges[k]}
							name={forecast.gauges[k].name || config.sites[k].name}
							liveFlow={liveFlow(liveData, k)}
						/>
					))}

				{live && (
					<footer className="wis-forecast-foot">
						{/* generation time, not issue time: the model refreshes
						    every 6h against the same 3 PM anchor, and the label
						    should show that the rain outlook is current */}
						{updatedLabel(forecast.generated_at)} · modeled estimates
						with expected range · water clarity is a rough estimate from
						recent storms — always check conditions before you swim.
					</footer>
				)}

				<div className="wis-links">
					<a className="wis-link-btn" href="/model-performance.html">
						Model performance
					</a>
					<a className="wis-link-btn" href="/model-card.html">
						About the model
					</a>
				</div>
			</div>
		</section>
	);
}

export default ForecastSection;
